import { CompressOperationGroup } from './compress-group/download-group.types';
import { MultipleDownloadOperationGroup } from './download-group/download-group.types';

export enum OperationGroupType {
  Upload = 'upload',
  MultipleDownload = 'multiple-download',
  Compress = 'compress',
}

export enum OperationStatus {
  Pending = 'pending',
  InProgress = 'in-progress',
  Failed = 'failed',
  Canceled = 'canceled',
  Succeeded = 'succeeded',
}

export enum FileUploadStatusType {
  Uploading = 'uploading',
  Failed = 'failed',
  Canceled = 'canceled',
  Uploaded = 'uploaded',
}

export interface FileUploadInProgress {
  type: FileUploadStatusType.Uploading;
  clientId: string;
  file: File;
  path: string;
}

export interface FileUploadFailed {
  type: FileUploadStatusType.Failed;
  clientId: string;
  file: File;
  path: string;
}

export interface FileUploadCanceled {
  type: FileUploadStatusType.Canceled;
  clientId: string;
  file: File;
}

export interface FileUploadSucceeded {
  type: FileUploadStatusType.Uploaded;
  clientId: string;
  fileId: string;
}

export type FileUploadStatus =
  | FileUploadInProgress
  | FileUploadFailed
  | FileUploadCanceled
  | FileUploadSucceeded;

export interface FileUploadOperation {
  id: string;
  name: string;
  size: number | undefined;
  progress?: number;
  status: FileUploadStatus;
}

export interface UploadOperationGroup {
  type: OperationGroupType.Upload;
  id: string;
  fileClientIdsList: string[];
}

export type OperationGroup =
  | UploadOperationGroup
  | MultipleDownloadOperationGroup
  | CompressOperationGroup;

export interface JobOperationContext {
  operationType: OperationGroupType;
  groupId: string;
}
